import { useSelector } from 'react-redux';
import { selectConfigurators } from '../../selectors';

export const useConfiguratorsList = () => {
	const configurators = useSelector(selectConfigurators);

	return { configurators };
};
